import React, { Component } from 'react'
import { Modal, Button,Spin } from 'antd'
import { app, api } from '../../app'
import './SupervisorEchoList.css'

export default class SupervisorEchoList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading:true,
            supervisorEchoList: [], //督察回声列表数据
            page: 1,
            supervisorEcho_modal: false, //督察回声详情弹窗
            supervisorEcho_detail: {}    //督察回声详情
        }
    }
    componentDidMount() {
        this.get_supervisorEchoList(1)
    }
    /* 
    *   请求督察回声列表数据
    *   page页数
    * 
     */
    get_supervisorEchoList = async (page = 1) => {

        this.setState({
            page,
            loading:true
        })
        let { data, flag, msg } = await app.post(api.InspectionInspectorEchoList, { page })
        if (flag == 1) {
            this.setState({
                supervisorEchoList: this.state.supervisorEchoList.concat(data)
            },()=>this.setState({loading:false}))
        } else {
            app.alert(msg, 'error', '45%')
        }
    }

    /* 
    *   请求督察回声详情
    *   @id 回声数据id
    * 
     */
    get_supervisorEcho_detail = async (id) => {
        this.setState({
            loading:true
        })
        let { data, flag, msg } = await app.post(api.InspectionInspectorEchoDetails, { id })
        if (flag == 1) {
            this.setState({
                supervisorEcho_detail: data
            }, () => this.setState({
                supervisorEcho_modal: true,
                loading:false
            }))
        } else {
            app.alert(msg, 'error', '45%')
        }
    }

    render() {
        let { loading,supervisorEchoList, supervisorEcho_modal, supervisorEcho_detail } = this.state
        return (
            <Spin spinning={loading}>
                 <div>
                <div className="main">
                    <div className="content">
                        <div className="padd">


                            <div className="channel_tab"><span className="noline"><a href="javascript:;">
                                督查回声
   </a></span></div>
                            <div className="news_box">
                                <div className="list list_1 list_2" style={{ paddingBottom: 0, borderBottom: 'none' }}>
                                    <ul>
                                        {
                                            supervisorEchoList.length > 0 ? supervisorEchoList.map(i => {
                                                return <li className="line" key={i.id}>
                                                    <h4>
                                                        <a onClick={() => this.get_supervisorEcho_detail(i.id)}>{i.simple_reply}</a>
                                                        <span className="date">
                                                            {i.reply_time}
                                                        </span>
                                                    </h4>
                                                </li>
                                            }) : '暂无数据'
                                        }



                                    </ul>
                                </div>
                                <span className="public_more" id="public_chckmore"><a className="zl_more zl_morefzl " onClick={() => this.get_supervisorEchoList(this.state.page + 1)}>更多&gt;&gt;</a></span>



                            </div>
                        </div>
                    </div>
                </div>
                <Modal
                    visible={supervisorEcho_modal}
                    // title={previewTitle}
                    footer={null}
                    onCancel={() => this.setState({ supervisorEcho_modal: false })}
                    width={1300}
                >
                    <div >


                        <h2 style={{ fontSize: 22, textAlign: 'center' }}>{supervisorEcho_detail.title}</h2>
                        <h2 style={{ fontSize: 22, textAlign: 'center' }}>{supervisorEcho_detail.simple_reply}</h2>
                        <p style={{fontSize: 20,textAlign: 'center',paddingLeft:200,paddingRight:200 }}>
                            {supervisorEcho_detail.two_text}
                        </p>
                        <p style={{fontSize: 20,textAlign: 'center',paddingLeft:200,paddingRight:200 }}>
                            {supervisorEcho_detail.respond_to}
                        </p>
                        <p style={{fontSize: 20,textAlign: 'right',paddingLeft:200,paddingRight:200 }}>
                            {supervisorEcho_detail.reply_time}
                        </p>




                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 50 }}>
                        <Button style={{ width: 200, color: '#1890FF', marginRight: 30 }} onClick={() => this.setState({ supervisorEcho_modal: false })}>关闭</Button>
                    </div>
                </Modal>

            </div>
       
            </Spin>
            )
    }
}



// WEBPACK FOOTER //
// ./src/routes/inspection/SupervisorEchoList.jsx